import { render } from "./NcrmActivityCard.vue?vue&type=template&id=18a052b6&scoped=true"
import script from "./NcrmActivityCard.vue?vue&type=script&lang=js"
export * from "./NcrmActivityCard.vue?vue&type=script&lang=js"

import "./NcrmActivityCard.vue?vue&type=style&index=0&id=18a052b6&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18a052b6"]])

export default __exports__